/* Avis Geotab en direct : cartes noires (noir de la bannière) sous la cloche, sur toutes les pages. */
.geotab-alert-stack {
  position: fixed;
  z-index: calc(var(--z-index-modal) + 19);
  width: min(384px, calc(100% - 16px));
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}
.geotab-alert-card,
.geotab-alert-more {
  --geotab-alert-line: rgb(255 255 255 / 0.09);
  --geotab-alert-muted: #a8a29e;
  pointer-events: auto;
  border: 1px solid var(--geotab-alert-line);
  border-radius: 4px;
  background: #191613;
  color: #fafaf9;
  box-shadow: 0 18px 40px rgb(15 23 42 / 0.3), 0 3px 10px rgb(15 23 42 / 0.18);
}
.geotab-alert-card {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 11px;
  overflow: hidden;
  padding: 10px 12px;
}
.geotab-alert-icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: #3f5585;
  color: #fff;
}
/* Arrivée chez le client : sable des livraisons du Gantt ; le bleu reste au chargement. */
.geotab-alert-card.tone-delivery .geotab-alert-icon { background: #d3c195; color: #373018; }
.geotab-alert-card.tone-done .geotab-alert-icon { background: #15803d; }
/* Hors plan : orange brûlé, comme dans Geotab. */
.geotab-alert-card.tone-off .geotab-alert-icon { background: #c2410c; }
.geotab-alert-icon svg { width: 17px; height: 17px; }
.geotab-alert-head { display: flex; align-items: center; gap: 8px; min-width: 0; padding-right: 33px; }
.geotab-alert-driver { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 15.5px; font-weight: 800; line-height: 1.2; }
.geotab-alert-truck {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  height: 18px;
  padding: 0 5px;
  border: 1px solid rgb(255 255 255 / 0.3);
  border-radius: 3px;
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}
.geotab-alert-time { flex-shrink: 0; margin-left: auto; font-size: 13px; font-weight: 800; font-variant-numeric: tabular-nums; }
.geotab-alert-place { display: flex; align-items: center; gap: 6px; margin-top: 3px; }
.geotab-alert-what { min-width: 0; flex: 1; font-size: 13.5px; line-height: 1.3; color: var(--geotab-alert-muted); }
.geotab-alert-map {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 28px;
  height: 22px;
  border: 1px solid #6d83b8;
  border-radius: 4px;
  background: #3f5585;
  color: #fff;
  animation: geotab-alert-map-pulse 2.4s ease-in-out infinite;
}
.geotab-alert-map:hover,
.geotab-alert-map:focus-visible { animation: none; filter: brightness(1.2); }
.geotab-alert-map:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 2px; }
.geotab-alert-map svg { width: 17px; height: 17px; }
@keyframes geotab-alert-map-pulse {
  0%, 100% { filter: brightness(1); box-shadow: 0 0 0 0 rgb(109 131 184 / 0.15); }
  50% { filter: brightness(1.3); box-shadow: 0 0 0 3px rgb(109 131 184 / 0.4); }
}
@media (prefers-reduced-motion: reduce) {
  .geotab-alert-map { animation: none; }
}
.geotab-alert-what,
.geotab-alert-next { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.geotab-alert-what b { color: #fff; font-weight: 800; }
.geotab-alert-meta {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid var(--geotab-alert-line);
  font-size: 12px;
  line-height: 1.5;
  color: var(--geotab-alert-muted);
}
.geotab-alert-meta b { color: #fafaf9; font-weight: 700; }
.geotab-alert-chip {
  display: inline-flex;
  align-items: center;
  height: 18px;
  margin: 0 4px;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 800;
  vertical-align: 1px;
  font-variant-numeric: tabular-nums;
}
.geotab-alert-close {
  position: absolute;
  top: 10px;
  right: 12px;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  color: #78716c;
}
.geotab-alert-close:hover,
.geotab-alert-close:focus-visible { background: rgb(255 255 255 / 0.08); color: #fff; outline: none; }
.geotab-alert-close svg { width: 15px; height: 15px; }
/* Compte à rebours : la carte part à la fin ; la souris dessus l'arrête (onglet caché : il attend aussi). */
.geotab-alert-bar {
  position: absolute;
  inset: auto 0 0;
  height: 3px;
  background: #6d83b8;
  transform-origin: left;
  animation: geotab-alert-countdown var(--geotab-alert-ms, 12000ms) linear forwards;
}
.geotab-alert-card.tone-delivery .geotab-alert-bar { background: #d3c195; }
.geotab-alert-card.tone-done .geotab-alert-bar { background: #22a05a; }
.geotab-alert-card.tone-off .geotab-alert-bar { background: #e0773f; }
.geotab-alert-card:hover .geotab-alert-bar,
.geotab-alert-card:focus-within .geotab-alert-bar { animation-play-state: paused; }
@keyframes geotab-alert-countdown { from { transform: scaleX(1); } to { transform: scaleX(0); } }
.geotab-alert-more {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  color: var(--geotab-alert-muted);
}
.geotab-alert-more b,
.geotab-alert-more .geotab-alert-more-go { color: #fff; font-weight: 800; }
.geotab-alert-more .geotab-alert-more-go { display: inline-flex; align-items: center; gap: 4px; margin-left: auto; white-space: nowrap; }
.geotab-alert-more:hover { background: #26221e; }
.geotab-alert-dot { width: 8px; height: 8px; flex-shrink: 0; border-radius: 2px; background: #3f5585; }
.geotab-alert-dot.tone-delivery { background: #d3c195; }
.geotab-alert-dot.tone-done { background: #15803d; }
.geotab-alert-dot.tone-off { background: #c2410c; }
